import { DialogContent, DialogTitle } from "@mui/material";
import styles from "./promptsList.module.css";
import { ArrowLeft, Edit, Plus, Trash2, X } from "react-feather";
import PromptSearch from "./PromptSearch";
import { useAuth0 } from "@auth0/auth0-react";

const PromptListing = (props) => {
  const { isAuthenticated, user } = useAuth0();

  const isSMSChatPromptCreate = isAuthenticated && user["https://propertydek.com/permissions"].indexOf("smschat-prompt:create") > -1;
  const isSMSChatPromptUpdate = isAuthenticated && user["https://propertydek.com/permissions"].indexOf("smschat-prompt:update") > -1;
  const isSMSChatPromptDelete = isAuthenticated && user["https://propertydek.com/permissions"].indexOf("smschat-prompt:delete") > -1;

  return (<>
    <DialogTitle id="alert-dialog-title" className={`${styles.CustomTitle}`}>
      <button className={`${styles.BackAddBU}`} onClick={(e) => props?.handleCloseModal(false)}>
        <ArrowLeft />
      </button>
      Prompts
      <button onClick={(e) => props?.handleCloseModal(false)} className={`${styles.ModalCloseBU}`}>
        <X />
      </button>
    </DialogTitle>
    <DialogContent className={`${styles.RequestBodyPop}`}>
      <div className={`${styles.PromptListMainSec}`}>
        <div className={`${styles.PromptListSearchSec}`}>
          <PromptSearch {...props} />
          {isSMSChatPromptCreate && <button className={`${styles.AddPromptBU}`} onClick={() => props?.setIsShowAddEditForm(true)}>
            <Plus /> prompt
          </button>}
        </div>
        {props?.promptList?.length > 0 && props?.promptList.map((prompt) => {
          return (<div key={prompt?.id} className={`${styles.PromptListSec}`}>
            <div className={`${styles.PromptList}`}>
              <div>
                <p className={`${styles.Title}`}>{prompt?.title}</p>
                <p className={`${styles.Des}`}>{prompt?.description}</p>
              </div>
              {isSMSChatPromptUpdate && <button onClick={(e) => props.setDetails(prompt)} className={`${styles.PromptListEditBU}`}>
                <Edit />
              </button>}
              {isSMSChatPromptDelete && <button onClick={(e) => { props.setOpenPromptDeleteModal(true); props.setPromptId(prompt.id); }} className={`${styles.PromptListEditBU}`}>
                <Trash2 />
              </button>}
            </div>
          </div>);
        })}

        {!props?.promptList?.length > 0 && (<div className={`${styles.NoDataMain}`}>
          <div className={`${styles.NoDataIMG}`}>
            <img src="/static/img/no-prospect.png" alt="No Data" />
          </div>
          <p className={`${styles.NoDataText}`}>Let's get started!</p>
          <p className={`${styles.NoDataTextSub}`}>Your prompt list is empty.</p>
        </div>)}
      </div>
    </DialogContent>
  </>);
};

export default PromptListing;